export default function ContactCard({ icon, label, value, href, tid, external }) {
  const inner = (
    <div className="card-surface p-6 h-full transition-all hover:-translate-y-0.5 hover:shadow-lg">
      <div className="w-10 h-10 rounded-xl bg-[var(--secondary)]/15 flex items-center justify-center mb-4 text-[var(--primary)]">
        {icon}
      </div>
      <div className="label-eyebrow">{label}</div>
      <div className="font-bold text-[var(--heading)] mt-1 break-words">{value}</div>
    </div>
  );

  if (href) {
    const extraProps = external
      ? { target: "_blank", rel: "noopener noreferrer" }
      : {};
    return (
      <a href={href} className="block" data-testid={tid} {...extraProps}>
        {inner}
      </a>
    );
  }
  return <div data-testid={tid}>{inner}</div>;
}
